let globalSplideInstance;

document.addEventListener('DOMContentLoaded', () => {
  globalSplideInstance = new Splide('.splide');

  globalSplideInstance.on('move', () => {
    // Remove the zoomed class from any element that has it
    const zoomedElement = document.querySelector('.splide__slide.zoomed');
    if (zoomedElement) {
      zoomedElement.classList.remove('zoomed');
    }

    // Reset the zoom state
    if (document.querySelector('product-modal')) {
      document.querySelector('product-modal').isZoomed = false;
    }
  });
  
  globalSplideInstance.mount();
});

document.querySelectorAll('.thumbnail-list__item').forEach((item, index) => {
  item.addEventListener('click', () => {
    globalSplideInstance.go(index); // Navigate Splide to the index of the clicked thumbnail
  });
});

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.isZoomed = false;
        this.addEventListener('click', this.toggleZoom.bind(this));
      }

      hide() {
        if (event.target.closest('.product-media-modal__toggle')) {
          super.classList.remove('animate-grow');
          super.hide();
          this.isZoomed = false; // Reset zoom state when hiding the modal
          const zoomedElement = this.querySelector('.zoomed');
          if (zoomedElement) {
            zoomedElement.classList.remove('zoomed');
          }
        }
      }

      show(opener) {
        super.show(opener);
        super.classList.add('animate-grow');
        this.showActiveMedia();
        // Use the existing global Splide instance instead of creating a new one
      }

      showActiveMedia() {
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (activeMedia) {
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')) {
            activeMedia.loadContent();
          }
        }
      }
      toggleZoom(event) {
        // Check if the clicked element is not the close button or the splide arrows
        if (!event.target.closest('.product-media-modal__toggle') && !event.target.closest('.splide__arrow')) {
          const activeSlide = this.querySelector('.splide__slide.is-active.is-visible img');
          if (activeSlide) {
            this.isZoomed = !this.isZoomed;
            if (this.isZoomed) {
              activeSlide.classList.add('zoomed');
            } else {
              activeSlide.classList.remove('zoomed');
            }
          }
        }
      }
    }
  );
}

